import { LocalException } from './errorHelper';
import { isObject, valueIsEmpty } from './utilHelper';

export const routes = {
  home: '/',

  list_notifications: '/notifications',
  view_notification: '/notification/:id',

  list_messages: '/messages',

  setup_profile_terms: '/profile/setup/terms',
  setup_profile_billing: '/profile/setup/billing',
  setup_profile_shipping: '/profile/setup/shipping',
  setup_profile_contact: '/profile/setup/contact',
  setup_profile_credentials: '/profile/setup/credentials',
  setup_profile_experience: '/profile/setup/experience',
  setup_profile_area: '/profile/setup/area',

  view_profile: '/profile',

  list_notary_bids: '/notary-bids',
  view_notary_bid: '/notary-bid/:id',

  list_orders: '/orders',
  view_order: '/order/:id',
  view_order_messages: '/order/:id/messages/:channel',
  view_order_channel: '/order/:id/channels/:channel/',
  view_order_flow: '/order/:id/flow',
  new_order_doc: '/order/:id/doc',

  list_notary_accounting: '/notary-accounting',

  view_documents: '/documents',
  view_terms: '/terms',

  meet_scheduler: '/order/:id/meet/scheduler',

  list_help: '/help',

  glba_general_information: '/glba-general-information',
  glba_security_practices: '/glba-security-practices',
  glba_access_retention_policies: '/glba-access-retention-policies',

  view_notary_mobile_app: '/notary-mobile-app',

} as const;

export type RouteKey = keyof typeof routes;
export type RouteValue = typeof routes[RouteKey];

export const route = (
  route: string,
  params?: string | string[] | Record<string, string | number | null | undefined> | null,
  query?: string | Record<string, any> | null
): string => {
  if (!(Object.values(routes) as string[]).includes(route)) {
    throw new LocalException(`Unknown route '${route}'`);
  }
  if (!valueIsEmpty(params)) {
    if (Array.isArray(params)) {
      params.forEach(param => {
        // handle optional params
        if (valueIsEmpty(param)) {
          route = route.replace(new RegExp('/:([a-zA-Z]+)'), '');
        } else {
          route = route.replace(new RegExp(':([a-zA-Z]+)'), String(param));
        }
      });
    } else if (isObject(params)) {
      const paramsObj = params as Record<string, string | number | null | undefined>;
      for (let key in paramsObj) {
        // handle optional params
        if (valueIsEmpty(paramsObj[key])) {
          route = route.replace(new RegExp(`/:${key}`), '');
        } else {
          route = route.replace(new RegExp(`:${key}`), String(paramsObj[key]));
        }
      }
    } else {
      // handle optional params
      if (valueIsEmpty(params)) {
        route = route.replace(new RegExp('/:([a-zA-Z]+)'), '');
      } else {
        route = route.replace(new RegExp(':([a-zA-Z]+)'), String(params));
      }
    }
  }
  if (query) {
    if (isObject(query)) {
      const queryObj = query as Record<string, any>;
      let parts: string[] = [];
      for (let key in queryObj) {
        if (Array.isArray(queryObj[key])) {
          queryObj[key].forEach((value: any) => {
            parts.push(`${key}[]=${value}`);
          });
        } else if (isObject(queryObj[key])) {
          const nestedObj = queryObj[key] as Record<string, any>;
          for (let key2 in nestedObj) {
            parts.push(`${key}[${key2}]=${nestedObj[key2]}`);
          }
        } else {
          parts.push(`${key}=${queryObj[key]}`);
        }
      }
      route += `?${parts.join('&')}`;
    } else {
      route += `?${query}`;
    }
  }
  return route;
};